import { TableCell, TableRow } from '@/ui'

import * as styles from './index.css'

type TableRowTextProperties = {
    label: string
    colSpan: number
}

export const TableRowText = ({
    label,
    colSpan,
}: Readonly<TableRowTextProperties>): JSX.Element => {
    return (
        <TableRow>
            <TableCell
                className={styles.empty}
                colSpan={colSpan}
            >
                {label}
            </TableCell>
        </TableRow>
    )
}
